module.exports = __webpack_public_path__ + "img/right_eight.56ebbe2c.svg";